import React, { useState, useEffect } from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaTrash } from "react-icons/fa";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
export default function CartPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cartData, setCartData] = useState([]);
    useEffect(() => {
        fetchCartData();
    }, []);
    const fetchCartData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "cart/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setCartData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const updateQty = async (cartItemId, qty) => {
        if (qty < 1) return;
        const qtyUpdate = {
            "cart_item_id": cartItemId,
            quantity: qty
        }
        try {
            let url = webEndPoint + "cart/update";
            const response = await makeRequest("put", url, qtyUpdate);
            if (response) {
                setCartData(prev =>
                    prev.map(item =>
                        item.rfId === cartItemId
                            ? { ...item, quantity: qty }
                            : item
                    )
                );
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const removeItem = async (cartItemId) => {
        setLoading(true);
        try {
            let url = webEndPoint + "cartItem/" + cartItemId;
            const response = await makeRequest("delete", url);
            if (response) {
                fetchCartData();
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const subtotal = cartData?.items?.reduce(
        (acc, item) => acc + Number(item.price) * item.quantity,
        0
    ) || 0;
    const handleClick = (id) => {
        navigate(`/user-checkout`);
    };
    return (
        <div>
            <Loader loading={loading} />
            <Header />
            <div className="cart-container">
                <h2 style={{ width: "100%", textAlign: "center" }}>My Cart</h2>
                <div className="gradient-line"></div>
                {cartData?.length === 0 ? (
                    <p className="empty-msg">Your cart is empty!</p>
                ) : (
                    <>
                        <div className="cart-grid">
                            {cartData?.items?.map((item) => (
                                <div key={item.id} className="cart-card">
                                    <img src={item.color_image_url} alt={item.product_name} />
                                    <div className="cart-info">
                                        <p className="product-name">{item.product_name}</p>
                                        <p className="product-price">₹{item.price}</p>
                                        <div className="cart-qty">
                                            <label className="product-price">Qty: </label>
                                            <input
                                                className="product-price"
                                                type="number"
                                                min="1"
                                                value={item.quantity}
                                                onChange={(e) => updateQty(item.rfId, parseInt(e.target.value))} />
                                        </div>
                                        <button className="remove-btn" onClick={() => removeItem(item.rfId)}>
                                            <FaTrash /> Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="cart-summary">
                            <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
                            <button className="checkout-btn" onClick={()=>handleClick()}>Proceed to Checkout</button>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    )
}